import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../store";
import {setTheme} from "../../store/actions/meta.action.ts";


export const useThemeConfig = () => {
    // Access the current theme from Redux state
    const currentTheme = useSelector((state: RootState) => state.meta?.currentTheme) || 'light';
    const dispatch = useDispatch();

    // Toggle theme and update both Redux and localStorage
    const toggleThemeHandler = () => {
        const newTheme = currentTheme === 'dark' ? 'light' : 'dark';
        dispatch(setTheme(newTheme));  // Dispatch Redux action to update theme
        localStorage.setItem('theme', newTheme);  // Persist theme in localStorage
    };

    return {currentTheme, toggleTheme: toggleThemeHandler};
};
